import BrandProvider from '../../../../../providers/BrandProvider';
import { useRootSelector } from '../../../../../store/hooks';
import { selectSiteHeader } from '../../../../../store/features/siteHeader';
import {
  selectPageConfig,
  TenantDomainId,
} from '../../../../../store/features/pageConfig';
import { selectPricingPackagesCount } from '../../../store/features/packages';
import { getTicketsCount } from '../../../helpers/basket/getTicketsCount';

import ScrollToTop from '../../../../common/ScrollToTop';
import MultiLevelNav from '../../../../layouts/SiteLayout/layoutComponents/MultiLevelNav/MultiLevelNav';
import MiniBasketButton from '../../components/basketElements/MiniBasketButton';

import { NavDesktopOnly, StyledSticky } from './styles';

const tenantsWithMobileLogo = [
  TenantDomainId.MIDDLEEASTFILMCOMICCON,
  TenantDomainId.FANEXPOHQ,
  TenantDomainId.INTERIORDESIGNSHOW,
];

export default function NavigationMenu() {
  const { tenantId } = useRootSelector(selectPageConfig);
  const {
    data: { navBarLogoEnabled, scrollToTopEnabled },
  } = useRootSelector(selectSiteHeader);
  const packagesCount = useRootSelector(selectPricingPackagesCount);

  const ticketsCount = getTicketsCount(packagesCount);
  const enableMobileLogo = tenantsWithMobileLogo.includes(tenantId);

  return (
    <BrandProvider>
      <StyledSticky>
        <MultiLevelNav
          topNav
          withHomeNav={navBarLogoEnabled}
          withMobileLogo={enableMobileLogo}
          miniBasket={
            ticketsCount && (
              <MiniBasketButton ticketsCount={ticketsCount} sx={{ mr: 2 }} />
            )
          }
        />
        {scrollToTopEnabled && <ScrollToTop />}
      </StyledSticky>

      <NavDesktopOnly>
        {/*
          MultiLevelNav with fixedNav:
          This displays a fixed second-level menu when the current page route matches a menu item at this level.
        */}
        <MultiLevelNav fixedNav />
      </NavDesktopOnly>
    </BrandProvider>
  );
}
